import { render, staticRenderFns } from "./ProjectsStats.vue?vue&type=template&id=49a5cc29"
import script from "./ProjectsStats.vue?vue&type=script&lang=js"
export * from "./ProjectsStats.vue?vue&type=script&lang=js"
import style0 from "./ProjectsStats.vue?vue&type=style&index=0&id=49a5cc29&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports